import { tw } from "@careinfo/tailwind";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import TextField from "../Reusable/TextField";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
import LocalCombobox from "../Reusable/LocalCombobox";
import { yupResolver } from "@hookform/resolvers/yup";
import { validateParty } from "../../validation/PartyInfo.tsx/Index";
import FormCheckbox from "../Reusable/CheckBox";

const CreateParty = ({ setOpenUserFormPopup, setValue: setParty }) => {
  const {
    control,
    handleSubmit,
    setValue,
    register,
    clearErrors,
    getValues,
    setError,
    watch,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(validateParty),
    defaultValues: {
      account: {
        id: "d4e5f6a7-8b9c-4d1e-2f3a-5b6c7d8e9f0a",
        name: "Sundry Creditors",
      },
    },
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["party"],
  });

  const generateRandomPassword = (length = 10) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.CREATE_USER;
    const password = generateRandomPassword();
    const formData = {
      ...values,
      is_supplier: true,
      password,
      confirm_password: password,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setParty("party", res?.data);
        setOpenUserFormPopup((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const accountData = [
    {
      id: "d4e5f6a7-8b9c-4d1e-2f3a-5b6c7d8e9f0a",
      name: "Sundry Creditors",
    },
    // {
    //   id: "a17de76c-e2bf-4db1-9fbb-908002c43473",
    //   name: "Sundry Debtors",
    // },
  ];

  return (
    <form onSubmit={handleSubmit((data) => handleCreate(data, setError))}>
      <div className={tw`grid grid-cols-2 gap-x-2 px-4`}>
        <LocalCombobox
          data={accountData}
          errors={errors?.account}
          setValue={setValue}
          register={register("account")}
          name={"account"}
          clearErrors={clearErrors}
          value={getValues("account")}
          label={"Account Type"}
        />
        <TextField
          label="Supplier Name"
          control={control}
          name={"full_name"}
          placeholder=""
        />
        <TextField
          label="PAN/VAT"
          control={control}
          placeholder=""
          name={"vat_pan"}
        />
        <TextField
          label="Address"
          control={control}
          name={"address"}
          placeholder=""
        />
        <PhoneNumberField
          control={control}
          label={"Mobile Number"}
          name={"mobile_number"}
          errors={errors?.mobile_number}
        />
        <div className={tw`mt-2`}>
          <TextField
            label="Email"
            control={control}
            name={"email"}
            placeholder=""
          />
        </div>
        <div className={tw`mt-2`}>
          <FormCheckbox
            name="is_supplier_customer"
            label="Customer"
            register={register}
            watch={watch}
            setValue={setValue}
          />
        </div>
      </div>
      <div className={tw`w-full px-4`}>
        <div className={tw`w-24 ml-auto `}>
          <Button label="Create" isLoading={isPostLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateParty;
